import React from 'react';
import {Button, ButtonProps, Img} from '@chakra-ui/react';

export interface GeoLogoNavProps extends ButtonProps {
	src?: string;
	extended?: boolean;
}

export const GeoLogoNav: React.FC<GeoLogoNavProps> = ({
	src,
	extended,
	...props
}: GeoLogoNavProps) => {
	return (
		<Button
			variant={props.variant}
			sx={{
				_focus: {outline: 0}
			}}
			// bg='white'
			onClick={props.onClick}
		>
			<Img
				src={`/images/${src}.svg`}
				height='3.1em'
				// maxHeight={props.extended ? '52px' : null}
				// minHeight={props.extended ? null : '52px'}
				width='3em'
				minWidth='50px'
				maxWidth='100px'
			/>
		</Button>
	);
};
